import { Components, Theme } from '@mui/material'

declare module '@mui/material/FormControlLabel' {
  interface FormControlLabelProps {
    'data-is-ai-prefilled'?: boolean
  }
}

export const MuiFormControlLabel: Components<Omit<Theme, 'components'>>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: ({ theme, 'data-is-ai-prefilled': dataIsAiPrefilled }) => ({
      ...theme.typography['body-regular'],
      color: theme.palette.text.default,
      '&:has(.MuiCheckbox-root)': {
        // Negative margin to align left edge of checkbox with left edge of other elements
        marginLeft: theme.spacing(-2),
      },
      '&:has(.MuiSwitch-root)': {
        // MUI spaces a label off its control with negative margins sized for the control's own
        // padding, which the Switch theme removes — so they would pull the label onto the switch.
        // Space the pair explicitly instead, at the 12px the design specifies for either placement.
        gap: theme.spacing(3),
        marginLeft: 0,
        marginRight: 0,
      },
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: theme.palette.text.default,
      },
      '&:not(.Mui-disabled) .MuiFormControlLabel-label': {
        backgroundColor: dataIsAiPrefilled ? theme.palette.bg.ai.muted : undefined,
      },
    }),
    asterisk: ({ theme }) => ({
      color: theme.palette.text.danger.default,
    }),
  },
}
